module.exports = __webpack_public_path__ + "fd4a5c018000912ebf320c924a2c48a2.svg";